<ng-container *ngIf="auth.isUserLoggedIn()">
  <button
    class="btn theme-light profile-button container-theme-light-icons"
    [ngClass]="{ avatar: variant == 'avatar', menu: variant == 'menu' }"
    [matMenuTriggerFor]="profileMenu"
  >
    <ng-container *ngIf="variant == 'avatar'">
      <app-avatar [imgSrc]="profilePicture" />
    </ng-container>

    <i class="fas fa-bars" *ngIf="variant == 'menu'"></i>
  </button>
  <mat-menu #profileMenu="matMenu" xPosition="before" yPosition="below">
    <button mat-menu-item (click)="onProfileClick()">
      {{ 'public.profile.myProfileTitle' | translate }}
    </button>
    <button mat-menu-item (click)="onLoyaltyClick()" *ngIf="loyaltyEnabled">
      {{ 'public.profile.loyaltyPointsTitle' | translate }}
    </button>
    <button mat-menu-item (click)="onLogoutClick()">
      {{ 'public.checkout.logout' | translate }}
    </button>
  </mat-menu>
</ng-container>
